import { BI_METADATA_API_BASE_URL_V7, STUDIO_API_BASE_URL_V5 } from '../config';

export const npiListAPIRoutes = {
  publishNpiList: () => `${STUDIO_API_BASE_URL_V5}/create_npi_list`,
  downloadNPIs: () => `${STUDIO_API_BASE_URL_V5}/download_npis`,
  getNPIListMetadata: () => `${BI_METADATA_API_BASE_URL_V7}/npi_list_metadata`,
  removeNPIList: () => `${STUDIO_API_BASE_URL_V5}/delete_npi_list`,
};
